import Vue from 'vue'

export default new Vue({
  data: {
    langLoaded: false
  }
})


// WEBPACK FOOTER //
// ./src/store.js